import React, { useEffect, useState } from "react";
import "./subjectCards.scss";
import avatarPlaceholder from "../../../../assets/placeholder/avatar_placeholder.png";
import ToggleSwitch from "../../ToggleSwitch";
import DeleteAlert from "../../DeleteAlert";
import * as appRoutes from "../../../../routes/routeConstants/appRoutes";
import {
  withRouter,
  generatePath,
  RouteComponentProps,
} from "react-router-dom";
import SubjectForm from "../SubjectForm";
import CardMenu from "../CardMenu";
import SubjectService from "../../../../services/CourseServices/SubjectService/subject.service";
import { convertJSONToFormData } from "../../../utils/converJsonToFormData";
import { ExamSubjectsService } from "../../../../services/ExamService/SubjectService/subject.service";
import { Badge } from "antd";
interface SubjectCardProps extends RouteComponentProps {
  courses: any[];
  refreshList: any;
  currentPageNumber: number;
  classroomId?: number;
  examId?: number;
}
const SubjectCards = (props: any) => {
  const { courses, refreshList, currentPageNumber, classroomId, examId } =
    props;

  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const [currentSubject, setCurrentSubject] = useState<any>("");
  const [courseList, setCourseList] = useState(courses);
  const path = props.location.pathname;

  useEffect(() => {
    setCourseList(courses);
  }, [courses]);
  const handleStatusToggle = (subjectId: number, checked: boolean) => {
    if (path.includes("exams")) {
      const jsonData = { exam_subject: { is_active: checked } };

      ExamSubjectsService.updateExamSubject(
        subjectId,
        jsonData,
        (response: any) => {
          refreshList(currentPageNumber);
        },
        (error: any) => {}
      );
    } else {
      const jsonData = { class_room_subject: { is_active: checked } };

      SubjectService.updateClassroomSubject(
        subjectId,
        jsonData,
        () => {
          refreshList(currentPageNumber);
        },
        () => {},
        () => {}
      ).then();
    }
  };

  const handleDelete = () => {
    if (path.includes("exams")) {
      ExamSubjectsService.deleteExamSubject(
        {
          subjectId: currentSubject.id,
        },
        (response: any) => {
          console.log(response);
          setCourseList(
            courses.filter((data: any) => data.id !== currentSubject.id)
          );
          // refreshList(currentPageNumber);
          setDeleteVisible(false);
        },
        (error: any) => {}
      );
    } else {
      SubjectService.deleteClassroomSubject(
        currentSubject.id,
        () => {
          refreshList(currentPageNumber);
          setDeleteVisible(false);
        },
        () => {},
        () => {}
      ).then();
    }
  };

  return (
    <div>
      <SubjectForm
        title="Edit Subject"
        visible={formVisible}
        setVisible={setFormVisible}
        data={currentSubject}
        refreshList={refreshList}
        currentPageNumber={currentPageNumber}
        examId={examId}
      />
      <DeleteAlert
        title={currentSubject?.name}
        logo={currentSubject?.subject?.displayPictureUrl}
        detail={(currentSubject?.numberOfChapters || 0) + " Chapters"}
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText="Subject"
        deleteWarning={"This subject will be deleted under class 8,CBSE"}
        handleDelete={handleDelete}
      />
      {courseList.map((course: any) => (
        <div
          className="course__card"
          key={course.id}
          onClick={() => {
            if (path.includes("exams")) {
              props.history.push(
                generatePath(appRoutes.EXAM_SUBJECT_CHAPTERS, {
                  examId: props.match.params.examId,
                  examName: props.match.params.examName,
                  subjectId: course.id,
                  subjectName: course.name,
                })
              );
            } else {
              props.history.push(
                generatePath(appRoutes.COURSE_CHAPTERS, {
                  subjectName: course.name,
                  subjectId: course.id,
                  boardName: props.match.params.boardName,
                  boardId: props.match.params.boardId,
                  className: props.match.params.className,
                  classId: props.match.params.classId,
                })
              );
            }
          }}
        >
          <div className="course__logo">
            <img
              src={course?.subject?.displayPictureUrl || avatarPlaceholder}
              alt=""
            />
          </div>
          <div className="course__details">
            <div className="course__acronym">{course.name}</div>
            <div className="course__title">
              {course?.subjectStream ? (
                <span>{course.subjectStream?.name || "-"}</span>
              ) : (
                <span>General</span>
              )}
              <span className="class__subjects">
                {course.stream} <span className="details-separator" />{" "}
                {course.chapterCount || course.examChapterCount || 0} Chapters
              </span>
              {course.amountRupees && (
                <span className="class__fees">
                  {" "}
                  <span className="details-separator" /> {course.amountRupees}
                  <span className="details-separator" />{" "}ID: {course.id}
                </span>
              )}
            </div>
          </div>
          <div
            className="course__toggle"
            onClick={(event) => event.stopPropagation()}
          >
            <ToggleSwitch
              checked={course.isActive}
              handleChange={(checked) => handleStatusToggle(course.id, checked)}
            />
          </div>
          <div
            className="course-menu-trigger"
            onClick={(event) => {
              event.stopPropagation();
              if (path.includes("exams")) {
                setCurrentSubject(
                  courseList.filter((data: any) => data.id == course.id)[0]
                );
              } else {
                setCurrentSubject(
                  courseList.filter((obj: any) => obj.id === course.id)[0]
                );
              }
            }}
          >
            <CardMenu
              menuText="Subject"
              handleEdit={setFormVisible}
              handleDelete={setDeleteVisible}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default withRouter(SubjectCards);
